import { useState } from "react";
import axios from "axios";
import MarkdownRenderer from "../MarkDown";
import { server2 } from "../../constant/config";
import { useAuthConfig } from "../../hooks/useAuthConfig";
import { useSearchParams } from "react-router-dom";

const RenderMtp = ({ paper, id, i }) => {
  const [open, setOpen] = useState(false);
  const [searchParams] = useSearchParams();
  const boardId = searchParams.get("board");
  const subjectId = searchParams.get("subject");
  const gradeId = searchParams.get("class");
  const handleToggle = async () => {
    if (open) {
      setOpen(false);
      return;
    }

    setOpen(true);
  };
  const authConfig = useAuthConfig();
  const handleDelete = async () => {
    try {
       await axios.delete(
        `${server2}/v1/mtpai/${id}`,
        authConfig
      );
      alert("Model Test Paper Deleted Successfully");
      window.location.reload();
    } catch (error) {
      console.error("Error deleting Model Test Paper:", error);
      alert("Failed to delete Model Test Paper. Please try again.");
    }
  };

  return (
    <div className="bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition-shadow p-5">
      
      {/* Header */}
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-center gap-3">
          <span className="w-8 h-8 flex items-center justify-center rounded-full bg-blue-100 text-blue-700 text-sm font-semibold">
            {i + 1}
          </span>

          <h2 className="text-lg font-semibold text-gray-800">
            {paper.title || "Model Test Paper"}
          </h2>
        </div>

        <button
          onClick={handleToggle}
          className="text-sm font-medium text-blue-600 hover:text-blue-700"
        >
          {open ? "Hide Paper" : "View Paper"}
        </button>
      </div>

      {/* Collapsible Content */}
      <div
        className={`overflow-y-scroll transition-all duration-300 ease-in-out ${
          open ? "max-h-[800px] mt-4" : "max-h-0"
        }`}
      >
        <div className="border-t pt-4 text-sm text-gray-700 ">

          {paper.paper && (
            <MarkdownRenderer content={paper.paper} />
          )}
        </div>
      </div>

      {/* Footer Actions */}
      <div className="flex gap-3 mt-4">
        <button className="px-4 py-2 text-sm font-medium rounded-lg bg-yellow-500 text-white hover:bg-yellow-600" onClick={()=>window.open(`/editMtp?id=${id}&board=${boardId}&subject=${subjectId}&class=${gradeId}&number=${i+1}`)} >
          Edit
        </button>
      </div>
    </div>
  );
};

export default RenderMtp;
